import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Process from './pages/Process';
import Blog from './pages/Blog';
import BlogPostDetail from './pages/BlogPostDetail';
import Inquiry from './pages/Inquiry';
import Websites from './pages/Websites';
import TemplateDetailsPage from './pages/TemplateDetailsPage';
import Terms from './pages/Terms';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/process" element={<Process />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPostDetail />} />
          <Route path="/inquiry" element={<Inquiry />} />
          <Route path="/websites" element={<Websites />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/terms-conditions" element={<Terms />} />
          <Route path="/details/:themeId" element={<TemplateDetailsPage />} />
          <Route path="/websites/details/:themeId" element={<TemplateDetailsPage />} />
          <Route path="/websites/:themeId" element={<TemplateDetailsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;